var app = angular.module('leonardo');

var PermissionsListFilter = function () {
  var customLabels = {
    'permission_view_thoughtspot_reporting': 'Permission View Dashboard Reporting'
  };

  return function (role) {
    var names = [];
    angular.forEach(role.permissions, function(item, key) {
      if (_.includes(key, 'permission_')) {
        if (item) {
          if (customLabels[key]) {
            names.push(customLabels[key]);
          } else {
            var array = key.split('_');
            names.push(array.join(' ').replace(/\b\w/g, function(l){ return l.toUpperCase() }));
          }
        }
      }
    });
    return names.join(', ');
  };
};

app.filter('permissionsList', [PermissionsListFilter]);
